/*
 * Cookie consent page indicator and control elements
 */

const turnCookiesOnBtn = document.querySelector(
  '*[data-js-turn-on-cookies-btn]'
)
const turnCookiesOffBtn = document.querySelector(
  '*[data-js-turn-off-cookies-btn]'
)
const cookiesStatus = document.querySelector('*[data-js-cookie-status]')
const cookiesStatusOnTitle = document.querySelector(
  '*[data-js-cookie-status-on-title]'
)
const cookiesStatusOffTitle = document.querySelector(
  '*[data-js-cookie-status-off-title]'
)

if (
  cookiesStatus &&
  turnCookiesOffBtn &&
  turnCookiesOnBtn &&
  cookiesStatusOnTitle &&
  cookiesStatusOffTitle
) {
  function setCookieStatusOff() {
    cookiesStatus.classList.remove('cookie-status--on')
    cookiesStatus.classList.add('cookie-status--off')
    cookiesStatusOffTitle.removeAttribute('aria-hidden')
    cookiesStatusOnTitle.setAttribute('aria-hidden', true)
  }

  function setCookieStatusOn() {
    cookiesStatus.classList.remove('cookie-status--off')
    cookiesStatus.classList.add('cookie-status--on')
    cookiesStatusOnTitle.removeAttribute('aria-hidden')
    cookiesStatusOffTitle.setAttribute('aria-hidden', true)
  }

  const initialStatus = localStorage.getItem('cookie-status')
  if (initialStatus && initialStatus === 'reject') {
    setCookieStatusOff()
  } else {
    setCookieStatusOn()
  }

  let interval
  function initOneTrustListener() {
    if (!window.OneTrust) {
      if (!interval) {
        interval = setInterval(initOneTrustListener, 200)
      }
    } else {
      clearInterval(interval)
      OneTrust.OnConsentChanged(function (e) {
        // ON:  e.detail: ['C0002', 'C0004', 'C0003', 'C0001'] - allow all cookie types
        // OFF:  e.detail: ['C0001'] - allow essential cookie types
        if (e.detail.length > 1) {
          setCookieStatusOn()
        } else {
          setCookieStatusOff()
        }
      })
    }
  }
  initOneTrustListener()

  function turnOffCookies() {
    // Reject all non essential cookies
    OneTrust && OneTrust.RejectAll()
    localStorage.setItem('cookie-status', 'reject')
    // Set GA cookie opt in, cookieOptIn is a custom GA property we have added to enable/ disable tracking, see TagManagerHead.cshtml for more details
    window.dataLayer.push({
      cookieOptIn: false,
      event: 'setCookieOptIn',
    })
  }

  function turnOnCookies() {
    // Allow all non essential cookies
    OneTrust && OneTrust.AllowAll()
    localStorage.setItem('cookie-status', 'allow')
    // Set GA cookie opt in, cookieOptIn is a custom GA property we have added to enable/ disable tracking, see TagManagerHead.cshtml for more details
    window.dataLayer.push({
      cookieOptIn: true,
      event: 'setCookieOptIn',
    })
  }

  if (turnCookiesOnBtn) {
    turnCookiesOnBtn.addEventListener('click', turnOnCookies)
  }

  if (turnCookiesOffBtn) {
    turnCookiesOffBtn.addEventListener('click', turnOffCookies)
  }
}
